import { FunctionComponent, memo } from "react";
import { EllipsisMenu } from "@edgetier/client-components";
import UserEditAction from "./user-edit-action";
import UserReinviteAction from "./user-reinvite-action";
import UserRemoveAction from "./user-remove-action";
import { IProps } from "./user-actions-menu.types";
import { REINVITE_USER_ACTION_ENABLED, REMOVE_USER_ACTION_ENABLED } from "constants/feature-flags";
import "./user-actions-menu.scss";

/**
 * A dropdown menu to edit or reinvite a user
 * @param props.user        User selected to edit or reinvite
 */
const UserActionsMenu: FunctionComponent<IProps> = ({ user }) => (
    <div className="user-actions-menu">
        <EllipsisMenu placement="bottom-end" overflowContainer>
            <UserEditAction user={user} />
            {REINVITE_USER_ACTION_ENABLED && (
                <>
                    {/*
                        Show reinvite button when user hasn't signed in at least once
                        and is a Congnito user
                    */}
                    {!(user.lastAuthenticationDateTime instanceof Date) && typeof user.cognitoUserId === "string" && (
                        <UserReinviteAction user={user} />
                    )}
                </>
            )}
            {REMOVE_USER_ACTION_ENABLED && <UserRemoveAction user={user} />}
        </EllipsisMenu>
    </div>
);

export default memo(UserActionsMenu);
